function Create_slider() {
    console.log("executed slider");
    setTimeout(() => {
        var $dynamicGallery = $('.cloned-gallery');
        var $dynamicCarousel = $('.cloned-carousel');

        // Destroy existing Slick instances if present
        if ($dynamicGallery.hasClass('slick-initialized')) {
            console.log("Destroying slick on cloned-gallery");
            $dynamicGallery.slick('unslick');
            var product_active_alt = document.getElementById('product_active_img_alt')?.innerText;
            const parentElement = document.querySelector('.cloned-gallery');
            if (parentElement) {
                const childElements = parentElement.querySelectorAll('.PDP-media-gallery-wrapper');             
                childElements.forEach(child => {
                    if (child.getAttribute('variant-carousel') === product_active_alt) {
                        console.log("Keeping", child);
                    } else {
                        console.log("Removing", child);
                        child.remove();
                    }
                });                
                const clonedCarousel = document.querySelector('.cloned-carousel');
                const dynamicCarousels = clonedCarousel?.querySelectorAll('.dynamic-carousel') || [];                
                dynamicCarousels.forEach((carousel) => {
                    if (carousel.classList.contains('carousel-hidden')) {
                        console.log("Removing hidden carousel", carousel);
                        carousel.remove();
                    } else {
                        console.log("Keeping visible carousel", carousel);
                    }
                });
            }
        }

        if ($dynamicCarousel.hasClass('slick-initialized')) {
            console.log("Destroying slick on cloned-carousel");
            $dynamicCarousel.slick('unslick');
            var product_active_alt = document.getElementById('product_active_img_alt')?.innerText;
            const parentElement = document.querySelector('.cloned-gallery');
            if (parentElement) {               
                const childElements = parentElement.querySelectorAll('.PDP-media-gallery-wrapper');                
                childElements.forEach(child => {
                    if (child.getAttribute('variant-carousel') === product_active_alt) {
                        console.log("Keeping", child);
                    } else {
                        console.log("Removing", child);
                        child.remove();
                    }
                });
                
                const clonedCarousel = document.querySelector('.cloned-carousel');
                const dynamicCarousels = clonedCarousel?.querySelectorAll('.dynamic-carousel') || [];                
                dynamicCarousels.forEach((carousel) => {
                    if (carousel.classList.contains('carousel-hidden')) {
                        console.log("Removing hidden carousel", carousel);
                        carousel.remove();
                    } else {
                        console.log("Keeping visible carousel", carousel);
                    }
                });
            }
        }

        // console.log("Initializing slick on cloned-gallery");
        $dynamicGallery.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
               nextArrow: '<button type="button" class="slick-next custom-pdp-gallery-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            prevArrow: '<button type="button" class="slick-prev custom-pdp-gallery-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            fade: true,
            asNavFor: '.cloned-carousel'
        });

        // console.log("Initializing slick on cloned-carousel");
        $dynamicCarousel.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.cloned-gallery',
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>'
        });

        // console.log("Slider created");
    }, 500); 
}
